import { FieldDefinition } from "./fieldDefinitions";

export interface ImplantDto {
  implantId: number;
  materialType: string;
  manufacturer: string;
  modelName: string;
  userIdInserted: number;
  dateInserted: string;
  userIdUpdated: number;
  dateUpdated: string;
  userIdDeleted: number;
  dateDeleted: string;
}
export const implantKeyId = "implantId" as const;

export const implantFields: FieldDefinition[] = [
  { name: "materialType", label: "Τύπος Υλικού", type: "text", required: true },
  {
    name: "manufacturer",
    label: "Κατασκευαστής",
    type: "text",
    required: true,
  },
  { name: "modelName", label: "Όνομα Μοντέλου", type: "text", required: true },
  {
    name: "userIdInserted",
    label: "ID Χρήστη Εισαγωγής",
    type: "number",
    required: true,
  },
  {
    name: "dateInserted",
    label: "Ημερομηνία Εισαγωγής",
    type: "date",
    required: true,
  },
  {
    name: "userIdUpdated",
    label: "ID Χρήστη Ενημέρωσης",
    type: "number",
    required: false,
  },
  {
    name: "dateUpdated",
    label: "Ημερομηνία Ενημέρωσης",
    type: "date",
    required: false,
  },
  {
    name: "userIdDeleted",
    label: "ID Χρήστη Διαγραφής",
    type: "number",
    required: false,
  },
  {
    name: "dateDeleted",
    label: "Ημερομηνία Διαγραφής",
    type: "date",
    required: false,
  },
] as const;

type Field = (typeof implantFields)[number];

export const implantFormData: string[] = [
  "materialType",
  "manufacturer",
  "modelName",
];

export const implantFilters = implantFields.filter((f) =>
  ["materialType", "manufacturer", "modelName"].includes(f.name),
);
